import React, { useContext, useState, useEffect } from "react";
import { get, isEmpty, merge, isUndefined } from "lodash";
import { Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faPencilAlt } from "@fortawesome/pro-light-svg-icons";
import {
  faExclamationTriangle,
  faCheckCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { Formik, useFormikContext } from "formik";
import { Tabs, Tab } from "react-bootstrap";
import { AutoEnrollment } from "./AutoEnrollment";
import {
  LoaderWrapper,
  ManagePlanLayout,
  TabLeavingGuard,
} from "../../../components";
import {
  MANAGE_PLAN_ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  getPathWithParam,
  getAdvancedPathWithParam,
  ROUTES,
  synchronizeCollectionPlanGroups,
  synchronizeCollectionNew,
} from "../../../utils";
import {
  createPlanStore,
  setManagePlanToastInfo,
  savePlanDetailsAction,
  setManagePlanFlow,
  clearLocalCacheByModel,
  updateAutoEnrollment,
  setManagePlanLocalCache,
} from "../../../contexts";
import { useRouterParams, useDeepEffect, useRequest } from "../../../abstracts";
import ADIApplicableFields from "./ADIApplicable";
import { DefaultElectionContainer } from "./DefaultElectionContainer";
import { OtherInformation } from "./OtherInformation";
import {
  getEmployeeClassification,
  listInvestment,
  listSource,
  getEnrollment,
  saveEnrollmentSetting,
} from "../../../services";
import CompensationTableRow from "../../../components/CompensationTable/CompensationTableRow";

const iconMap = {
  faExclamationTriangle: faExclamationTriangle,
  faCheckCircle: faCheckCircle,
};
const iconsInitialValues = {
  Icolor: "#2F80ED",
  I: "faCheckCircle",
  I1color: "#2F80ED",
  I1: "faCheckCircle",
  I2color: "#2F80ED",
  I2: "faCheckCircle",
  I3color: "#2F80ED",
  I3: "faCheckCircle",
};
const getInitialValues = (autoEnrollment, investmentList, sourcesList) => {
  if (isEmpty(autoEnrollment)) return {};
  let tempInvestmentElectionBasedOnList = [];
  tempInvestmentElectionBasedOnList = tempInvestmentElectionBasedOnList.concat(
    (autoEnrollment?.investmentElectionBasedOnList ?? []).filter(
      (_) => _.isDefaultCategory
    )
  );
  tempInvestmentElectionBasedOnList = tempInvestmentElectionBasedOnList.concat(
    (autoEnrollment?.investmentElectionBasedOnList ?? []).filter(
      (_) => !_.isDefaultCategory
    )
  );
  const values = tempInvestmentElectionBasedOnList;
  const doubleDArrayOfValues = values.map((_) =>
    (_?.investmentElectionValuesList ?? []).map((x) => {
      return {
        ...x,
      };
    })
  );
  let singleDArrayOfValues = [];

  for (let i = 0; i < doubleDArrayOfValues.length; i++) {
    singleDArrayOfValues = singleDArrayOfValues.concat(doubleDArrayOfValues[i]);
  }
  const InvestmentElectionBasedOnList = values
    .filter((y) => !y.isDefaultCategory)
    .map((_) => {
      return {
        id: _.id,
        ageFrom: _.ageFrom,
        ageTo: _.ageTo,
        autoEnrollmentId: _.autoEnrollmentId,
        from: _.from,
        investmentBasedOn: _.investmentBasedOn,
        to: _.to,
        isDefaultCategory: _.isDefaultCategory,
      };
    });

  let autoEnrollmentInvestmentElections = [];
  let autoEnrollmentSouceInvestmentElections = [];
  let differentInvestmentElection = [];
  if (autoEnrollment?.sameInvestmentElectionToAllParticipants === true) {
    if (autoEnrollment?.sameInvestmentElectionToAllSources === true) {
      autoEnrollmentInvestmentElections = singleDArrayOfValues;
    } else if (autoEnrollment?.sameInvestmentElectionToAllSources === false) {
      for (let i in sourcesList) {
        const temp = singleDArrayOfValues.filter(
          (_) => _.sourceId === sourcesList[i].id
        );
        autoEnrollmentSouceInvestmentElections.push(temp);
      }
    }
  }
  // different classifications
  else if (autoEnrollment?.sameInvestmentElectionToAllParticipants === false) {
    if (autoEnrollment?.sameInvestmentElectionToAllSources === true) {
      let classificationGroup = [];
      for (let j in values) {
        const investmentGroup = singleDArrayOfValues
          .filter((_) => {
            if (_.investmentElectionBasedOnId === values[j].id) {
              return true;
            }
            return false;
          })
          .map((_) => {
            return { ..._, isDefaultCategory: values[j].isDefaultCategory };
          });
        classificationGroup.push(investmentGroup);
      }
      differentInvestmentElection.push(classificationGroup);
    } else if (autoEnrollment?.sameInvestmentElectionToAllSources === false) {
      for (let i in sourcesList) {
        let classificationGroup = [];
        for (let j in values) {
          const investmentGroup = singleDArrayOfValues.filter((_) => {
            if (
              _.sourceId === sourcesList[i].id &&
              _.investmentElectionBasedOnId === values[j].id
            ) {
              return true;
            }
            return false;
          });
          classificationGroup.push(investmentGroup);
        }
        differentInvestmentElection.push(classificationGroup);
      }
    }
  }

  /////////////// For getting initial investment added value from backend (for Investment Election) ////////////////
  let savedInvestments = [];
  if (autoEnrollment?.sameInvestmentElectionToAllSources === true) {
    if (autoEnrollment?.sameInvestmentElectionToAllParticipants === false) {
      const initialSaveInvestments = {
        [autoEnrollment?.sameInvestmentBasedOn]: [
          (differentInvestmentElection[0][0] ?? []).map((_) => {
            return {
              investmentId: _.investmentId,
              investmentName: _.investmentName,
            };
          }),
        ],
      };
      savedInvestments = initialSaveInvestments;
    } else if (
      autoEnrollment?.sameInvestmentElectionToAllParticipants === true
    ) {
      savedInvestments = !isEmpty(autoEnrollmentInvestmentElections)
        ? [...autoEnrollmentInvestmentElections]
        : [];
    }
  } else if (
    get(autoEnrollment, "sameInvestmentElectionToAllSources") === false
  ) {
    if (
      get(autoEnrollment, "sameInvestmentElectionToAllParticipants") === false
    ) {
      let jsonObject = {};
      for (let i in sourcesList) {
        jsonObject[i] = get(differentInvestmentElection, `${i}.0`, []);
      }
      savedInvestments = {
        [autoEnrollment?.sameInvestmentBasedOn]: jsonObject,
      };
    } else if (
      autoEnrollment?.sameInvestmentElectionToAllParticipants === true
    ) {
      savedInvestments = !isEmpty(autoEnrollmentSouceInvestmentElections)
        ? { ...autoEnrollmentSouceInvestmentElections }
        : [];
    }
  }
  /////////////////////////////////////////////////////////////////////////////////

  return {
    autoEnrollmentInvestmentElections: autoEnrollmentInvestmentElections,
    autoEnrollmentSouceInvestmentElections: autoEnrollmentSouceInvestmentElections,
    differentInvestmentElection: differentInvestmentElection,
    InvestmentElectionBasedOnList: InvestmentElectionBasedOnList,
    initialInvestmentElectionBasedOnList: values,
    savedInvestments: savedInvestments,
  };
};
export const synchronizeCollectionInvestmentElectionBasedOnList = (
  list,
  changedList,
  isAdditionalAutoEnrollment
) => {
  const newList = [
    ...changedList.map((_) => {
      const changedSubList = isAdditionalAutoEnrollment
        ? get(_, "additionalAutoEnrollmentInvestmentElectionValuesList")
        : get(_, "investmentElectionValuesList");
      const listFound = list.find((x) => x.id === _.id);
      const subList = isAdditionalAutoEnrollment
        ? get(listFound, "additionalAutoEnrollmentInvestmentElectionValuesList")
        : get(listFound, "investmentElectionValuesList");
      const label = isAdditionalAutoEnrollment
        ? "additionalAutoEnrollmentInvestmentElectionValuesList"
        : "investmentElectionValuesList";

      return {
        ..._,
        [label]: synchronizeCollectionNew(
          subList ?? [],
          changedSubList ?? [],
          "id"
        ),
        isDeleted: false,
      };
    }),
    ...(list ?? [])
      .filter((_) => !changedList.map((x) => x["id"]).includes(_["id"]))
      .map((_) => ({ ..._, isDeleted: true })),
  ];
  return newList;
};
const EnrollmentContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(createPlanStore);
  console.log("state", state);
  const [newFlow, setNewFlow] = useState("");
  const { planId, flow } = useRouterParams();
  const [sourceEnrollmentError, setSourceEnrollmentError] = useState(false);
  const formName = managePlanFormNames.ADD_ENROLLMENT;
  const fields = formFields[formName];
  const [keyValue, setkeyValue] = useState(
    get(state, "AutoEnrollment.tabOpenInAutoEnrollment", 1)
  );
  const [nextkeyValue, setNextkeyValue] = useState(keyValue);
  const [isInnerFormDirty, setIsInnerFormDirty] = useState(false);
  const [tabState, setTabState] = useState("visited");
  const initialValues = {};
  const initialValuesFromLocalCache = state?.AutoEnrollment;
  const [toggle, setToggle] = useState(false);
  const [icon, setIcon] = useState(faCheckCircle);
  const [iTabcolor, setITabcolor] = useState("#2F80ED");
  const [icolor, setIcolor] = useState("#2F80ED");
  const [i1, setI1] = useState(faCheckCircle);
  const [i1Tabcolor, setI1Tabcolor] = useState("#2F80ED");
  const [i1color, setI1color] = useState("#2F80ED");
  const [i2, setI2] = useState(faCheckCircle);
  const [i2Tabcolor, setI2Tabcolor] = useState("#2F80ED");
  const [i2color, setI2color] = useState("#2F80ED");
  const [i3, setI3] = useState(faCheckCircle);
  const [i3Tabcolor, setI3Tabcolor] = useState("#2F80ED");
  const [i3color, setI3color] = useState("#2F80ED");
  //const [ADI, setADI] = useState({});
  const [commonError, setCommonError] = useState("");
  const [Avalues, setAvalues] = useState({});
  const AdditionalAutoEnrollment = get(state, "AdditionalAutoEnrollment", []);
  const [isSaved1, setIsSaved1] = useState(false);
  const [isSaved2, setIsSaved2] = useState(null);
  const [isSaved3, setIsSaved3] = useState(null);
  const [isSuccessFullySaved, setIsSuccessFullySaved] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useDeepEffect(() => {
    if (isEmpty(initialValuesFromLocalCache)) {
      setIsLoading(true);
      getEnrollment(parseInt(planId))
        .then((res) => {
          setIsLoading(false);
          if (res.isSuccessful) {
            dispatch(
              setManagePlanFlow({
                enrollment: res?.enrollment,
              })
            );
          }
        })
        .catch((ex) => {
          setIsLoading(false);
        });
    }
    if (isEmpty(state?.listSource))
      listSource(parseInt(planId))
        .then((response) => {
          setSourceList(response.employerSourcesList);
          dispatch(
            setManagePlanLocalCache({
              model: "listSource",
              data: response,
            })
          );
        })
        .catch((error) => {
          //Handle Error
        });
    else setSourceList(state?.listSource?.employerSourcesList);

    if (isEmpty(state?.listInvestment))
      listInvestment(parseInt(planId))
        .then((response) => {
          setInvestmentList(response.investmentPlanMappings);
          dispatch(
            setManagePlanLocalCache({
              model: "listInvestment",
              data: response,
            })
          );
        })
        .catch((error) => {
          //Handle Error
        });
    else setInvestmentList(state?.listInvestment?.investmentPlanMappings);

    if (isEmpty(state?.employeeClassification))
      getEmployeeClassification(planId)
        .then((response) => {
          setEmployeeClassification(response);
          dispatch(
            setManagePlanLocalCache({
              model: "employeeClassification",
              data: response,
            })
          );
        })
        .catch((error) => {
          //Handle Error
        });
    else setEmployeeClassification(state?.employeeClassification);
  }, []);

  const enrollment = get(state, "enrollment", []);
  console.log("enrollment", enrollment);

  const ADI = enrollment?.autoDeferralncreaseApplicable;
  const autoEnrollment = enrollment?.autoEnrollment;
  let formValues = !isEmpty(autoEnrollment) ? autoEnrollment : {};

  const getDefaultElection = !isEmpty(enrollment)
    ? enrollment?.defaultElectionSetting ?? {}
    : Object.create(null);
  const getOtherInformationInitialValues =
    enrollment?.otherInformation && !isEmpty(enrollment.otherInformation)
      ? {
          [fields.allowReallocation]:
            enrollment?.otherInformation?.allowReallocation,
          [fields.numberOfDaysBeforeEntryDate]:
            enrollment?.otherInformation?.numberOfDaysBeforeEntryDate,
          [fields.numberOfReallocationAllowed]:
            enrollment?.otherInformation?.numberOfReallocationsAllowed,
          [fields.reAllocationPeriod]:
            enrollment?.otherInformation?.reallocationPeriod,
          [fields.sendEnrollmentInvite]:
            enrollment?.otherInformation?.sendEnrollmentInvite,
          id: enrollment?.otherInformation?.id,
        }
      : {
          [fields.allowReallocation]: false,
        };
  const planInvestment = getDefaultElection?.planInvestment ?? [];
  const [investmentsList, setInvestmentList] = useState([]);
  const [sourcesList, setSourceList] = useState([]);
  const [employeeClassification, setEmployeeClassification] = useState([]);

  const employeeDeferralSourceList = sourcesList.filter(
    (source) => source.sourceType === 1 && source.sourceCategory === 2
  );

  const adiSources = () =>
    employeeDeferralSourceList.map((source) => {
      var x = (enrollment?.autoDeferralncreaseApplicable?.adi ?? []).find(
        (_) => _.sourceId == source.id
      );
      if (x) {
        return {
          ...x,
          sourceName: source.sourceName,
        };
      } else {
        return {
          id: 0,
          autoDeferralIncreaseApplicableId: 0,
          sourceId: source.id,
          sourceName: source.sourceName,
          autoDeferralIncrease: null,
          maximumADI: null,
          minimumADI: null,
        };
      }
    });
  const autoDeferralncreaseApplicableADI =
    enrollment?.autoDeferralncreaseApplicable?.adi ?? [];
  const autoDeferralncreaseApplicable = !isEmpty(enrollment)
    ? {
        ...(enrollment?.autoDeferralncreaseApplicable ?? {}),
        adi: adiSources(),
      }
    : {
        enrollmentId: 0,
        id: 0,
        autoDeferralIncreaseProgram: false,
        periodOfIncrease: 0,
        autoDeferralIncrease:
          enrollment?.autoDeferralncreaseApplicable?.autoDeferralIncrease ?? 3,
        applyADITo: null,
      };

  const transformSourceList = (sourceListInput) => {
    return !isEmpty(sourceListInput)
      ? sourceListInput.map((e) => ({
          sourceId: e.id,
          sourceName: e.sourceName,
          contributionType: e.employeeDeferralSource?.contributionType,
          maximumRate: e.employeeDeferralSource?.limitMaximumDollar,
          minimumRate: e.employeeDeferralSource?.limitMinimumDollar,
          contributionRate: null,
        }))
      : [];
  };

  //default election
  const sourceList = transformSourceList(sourcesList);
  const transformedEmployeeDeferralSourceList = transformSourceList(
    employeeDeferralSourceList
  );

  const investmentList = !isEmpty(investmentsList)
    ? investmentsList.map((e) => ({
        investmentId: e.id,
        investmentName: e.name,
        investmentPercentage: null,
      }))
    : [];
  //let formValues = {};
  const menuChange = (key) => {
    setNextkeyValue(key);

    setITabcolor("#bdbdbd");
    setI1Tabcolor("#bdbdbd");
    setI2Tabcolor("#bdbdbd");
    setI3Tabcolor("#bdbdbd");

    if (key == 1) {
      setITabcolor("#007bff");
    } else if (key == 2) {
      setI1Tabcolor("#007bff");
    } else if (key == 3) {
      setI2Tabcolor("#007bff");
    } else {
      setI3Tabcolor("#007bff");
    }
  };
  const autoEnrollmentInitialValues = {
    [fields.isWindowPeriod]: true,
    [fields.usePlanDefaultDeferralElection]: true,
    autoEnrollmentDeferralSources: [
      {
        id: 0,
        deferralSourceName: null,
        limitMaximumDollar: 0,
        limitMinimumDollar: 0,
      },
    ],
    autoEnrollmentInvestmentElections: [
      //
      {
        investmentName: null,
      },
    ],
    autoEnrollmentSouceInvestmentElections: [
      //
      [
        //investmentElection=
        {
          investmentName: null,
        },
      ],
    ],
    categorywiseInvestments: [
      [
        {
          investmentName: null,
        },
      ],
    ],
    differentInvestmentElection: [
      //
      [
        [
          {
            investmentName: null,
          },
        ],
      ],
    ],
    [fields.subjecttoAutoEnrollment]: false,
    [fields.minimumWithdrawallimit]: 3,
    [fields.isAutoReEnroll]: false,
    [fields.usePlanDefaultInvestmentElection]: false,
    [fields.sameInvestmentElectionToAllParticipants]: true,
    [fields.sameInvestmentElectionToAllSources]: true,
    [fields.exclusionType]: 0,
    ...formValues,
    ...getInitialValues(autoEnrollment, investmentList, sourcesList),
    [fields.excludedEmploymentStatuses]: isEmpty(
      formValues.excludedEmploymentStatuses
    )
      ? null
      : (formValues?.excludedEmploymentStatuses ?? []).map(
          (val, ind) => val?.employmentStatusCode
        ),
    [fields.excludedEmployeeClassifications]: isEmpty(
      formValues.excludedEmployeeClassifications
    )
      ? null
      : formValues.excludedEmployeeClassifications?.map(
          (val, ind) => val?.code
        ),
  };
  // useEffect(() => {
  //   dispatch(clearLocalCacheByModel("AutoEnrollment"));
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  // useDeepEffect(() => {
  //   const editPath =  getPathWithParam({
  //     path: MANAGE_PLAN_ROUTES.ENROLLMENT,
  //     pathParam: [FLOW_TYPES.EDIT, planId],
  //   })
  //   if(location.pathname === editPath){
  //     dispatch(clearLocalCacheByModel("AutoEnrollment"));
  //   }
  // }, [location.pathname])

  useDeepEffect(() => {
    if (!isEmpty(getDefaultElection)) {
      setIcolor("#219653");
    }

    if (!isEmpty(ADI) && get(ADI, "autoDeferralIncreaseProgram", false)) {
      //setI1color("#219653");
    }

    if (
      !isEmpty(get(enrollment, "autoEnrollment", {})) &&
      get(enrollment, "autoEnrollment.subjecttoAutoEnrollment", false)
    ) {
      setI2color("#219653");
    }
  }, [toggle]);

  const buttons = [
    {
      onClick: () => {
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.ENROLLMENT,
            pathParam: [FLOW_TYPES.EDIT, planId],
          })
        );
      },
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: ROUTES.PLAN,
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.ENROLLMENT,
            pathParam: [FLOW_TYPES.SAVE, planId],
          })
        ),
    },
  ];

  const prepDataDefaultElectionSetting = (values) => {
    const deferralSourceContribution = get(
      values,
      "deferralSourceContributions",
      []
    ).map((_, ind) => {
      return {
        ..._,
        SourceId: get(
          transformedEmployeeDeferralSourceList,
          `${ind}.sourceId`,
          0
        ),
      };
    });
    const planInvestment = get(values, "planInvestment", []).map((e) => ({
      ...e,
      defaultElectionSettingsId: get(getDefaultElection, "id", 0),
    }));
    var defaultElectionSettingFormdata = get(
      values,
      "defaultElectionSetting",
      {}
    );
    const defaultElectionSetting = {
      id: get(getDefaultElection, "id", 0),
      deferralSourceContribution: synchronizeCollectionNew(
        get(
          enrollment,
          "defaultElectionSetting.deferralSourceContribution",
          []
        ),
        deferralSourceContribution,
        "id"
      ),
      planInvestment: synchronizeCollectionNew(
        get(enrollment, "defaultElectionSetting.planInvestment", []),
        planInvestment,
        "id"
      ),
    };
    return defaultElectionSetting;
  };
  const preDataAdi = (values) => {
    var adiapplicable = get(
      values,
      "autoDeferralncreaseApplicable.autoDeferralIncreaseProgram"
    );
    const adiList = isEmpty(
      get(values, "autoDeferralncreaseApplicable.adi", [])
    )
      ? get(values, "adi")
      : get(values, "autoDeferralncreaseApplicable.adi", []);

    const autoDeferralncreaseApplicable = {
      enrollmentId: get(
        values,
        "autoDeferralncreaseApplicable.enrollmentId",
        0
      ),
      id: get(values, "autoDeferralncreaseApplicable.id", 0),
      autoDeferralIncreaseProgram: adiapplicable,
      periodOfIncrease: adiapplicable
        ? get(values, "autoDeferralncreaseApplicable.periodOfIncrease")
        : null,
      autoDeferralIncrease: adiapplicable
        ? get(values, "autoDeferralncreaseApplicable.autoDeferralIncrease", 3)
        : null,
      applyADITo: adiapplicable
        ? get(values, "autoDeferralncreaseApplicable.applyADITo")
        : null,
      adi: adiapplicable
        ? synchronizeCollectionNew(
            get(enrollment, "autoDeferralncreaseApplicable.adi", []),
            adiList,
            "id"
          )
        : null,
    };
    return autoDeferralncreaseApplicable;
  };
  const prepareReallocationOtherInformation = (values) => {
    var otherInformation = get(values, "enrollmentOtherInformation", {});
    const enrollmentReallocationOtherInformation = {
      enrollmentId: get(enrollment, "id", 0),
      allowReallocation: get(otherInformation, "allowReallocation", ""),
      reAllocationPeriod: get(otherInformation, "reAllocationPeriod", ""),
      numberOfReallocationAllowed: get(
        otherInformation,
        "numberOfReallocationAllowed",
        ""
      ),
      sendEnrollmentInvite: get(otherInformation, "sendEnrollmentInvite", ""),
      numberOfDaysBeforeEntryDate: get(
        otherInformation,
        "numberOfDaysBeforeEntryDate",
        ""
      ),
    };
    return enrollmentReallocationOtherInformation;
  };

  const saveTab1 = () => {
    //setToggle(!toggle);
    //setIsSaved1(false);
    setIsSaved1(true);
    setIcon(faCheckCircle);
    setIcolor("#219653");
    setTabState("saved");
  };

  const commonSave = () => {
    history.push(
      getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ENROLLMENT,
        pathParam: [FLOW_TYPES.EDIT, planId],
      })
    );
    dispatch(
      setManagePlanToastInfo({
        showToast: true,
        toastMessage: "Data saved successfully",
      })
    );
  };

  const convertAutoEnrollmentValues = (values) => {
    const Avalues = values?.autoEnrollment;
    let investmentElectionBasedOnList = [];
    if (Avalues[fields.usePlanDefaultInvestmentElection]) {
      let invBasedOnId = get(
        enrollment,
        `autoEnrollment.${fields.usePlanDefaultInvestmentElection}`,
        false
      )
        ? get(
            enrollment,
            "autoEnrollment.investmentElectionBasedOnList.0.id",
            0
          )
        : 0;
      investmentElectionBasedOnList.push({
        id: invBasedOnId,
        ageFrom: null,
        ageTo: null,
        autoEnrollmentId: get(enrollment, "autoEnrollment.id", 0),
        from: null,
        investmentBasedOn: null,
        to: null,
        investmentElectionValuesList: get(values, "planInvestment", []).map(
          (_) => {
            return {
              investmentElectionBasedOnId: invBasedOnId,
              autoEnrollmentId: get(enrollment, "autoEnrollment.id", 0),
              investmentName: _.investmentName,
              investmentId: _.investmentId,
              investmentPercentage: _.investmentPercentage,
              sourceId: null,
              sourceName: "",
            };
          }
        ),
      });
      return investmentElectionBasedOnList;
    }

    const autoEnrollmentInvestmentElectionsMap = Avalues.autoEnrollmentInvestmentElections?.map(
      (_, ind) => {
        return {
          ..._,
          autoEnrollmentId: get(enrollment, "autoEnrollment.id", 0),
          sourceId: get(_, "sourceNameId", ""),
          investmentElectionBasedOnId: get(_, "investmentElectionBasedOnId", 0),
          investmentName: get(_, "investmentName", ""),
          sourceName: get(_, "sourceName", ""),
          investmentId: get(
            investmentList.find(
              (inv) => inv.investmentName === _.investmentName
            ),
            "investmentId",
            null
          ),
        };
      }
    );

    //for diff source and same participants
    let autoEnrollmentSouceInvestmentElectionsList = [];
    for (let i in Avalues.autoEnrollmentSouceInvestmentElections) {
      // let sourceIdOfI = sourcesList[i].sourceId;
      for (let j in Avalues.autoEnrollmentSouceInvestmentElections[i]) {
        autoEnrollmentSouceInvestmentElectionsList.push({
          autoEnrollmentId: get(enrollment, "autoEnrollment.id", 0),
          sourceId:
            Avalues.autoEnrollmentSouceInvestmentElections[i][j].sourceId,
          investmentElectionBasedOnId: get(
            Avalues.autoEnrollmentSouceInvestmentElections[i][j],
            "investmentElectionBasedOnId",
            0
          ),
          investmentName: get(
            Avalues.autoEnrollmentSouceInvestmentElections[i][j],
            "investmentName",
            ""
          ),
          sourceName: get(
            Avalues.autoEnrollmentSouceInvestmentElections[i][j],
            "sourceName",
            ""
          ),
          investmentId: get(
            investmentList.find(
              (inv) =>
                inv.investmentName ===
                Avalues.autoEnrollmentSouceInvestmentElections[i][j]
                  .investmentName
            ),
            "investmentId",
            null
          ),
          investmentPercentage:
            Avalues.autoEnrollmentSouceInvestmentElections[i][j]
              .investmentPercentage,
        });
      }
    }

    //for diff participants
    let differentInvestmentElectionList = [];
    const differentInvestmentElection = Avalues.differentInvestmentElection;
    for (let i in differentInvestmentElection) {
      // let sourceIdOfI = Avalues.sameInvestmentElectionToAllSources ? null : sourcesList[i].sourceId;
      for (let j in differentInvestmentElection[i]) {
        // let investmentElectionBasedOnId = j;
        for (let k in differentInvestmentElection[i][j]) {
          differentInvestmentElectionList.push({
            autoEnrollmentId: get(enrollment, "autoEnrollment.id", 0),
            sourceId: get(
              differentInvestmentElection[i][j][k],
              "sourceId",
              null
            ),
            investmentElectionBasedOnId: get(
              differentInvestmentElection[i][j][k],
              "investmentElectionBasedOnId",
              0
            ),
            investmentName: get(
              differentInvestmentElection[i][j][k],
              "investmentName",
              ""
            ),
            sourceName: get(
              differentInvestmentElection[i][j][k],
              "sourceName",
              ""
            ),
            investmentElectionBasedOnIndex: j,
            investmentId: differentInvestmentElection[i][j][k].investmentId,
            investmentPercentage:
              differentInvestmentElection[i][j][k].investmentPercentage,
          });
        }
      }
    }

    if (Avalues.sameInvestmentElectionToAllParticipants === true) {
      investmentElectionBasedOnList.push({
        id: get(
          enrollment,
          "autoEnrollment.sameInvestmentElectionToAllParticipants",
          false
        )
          ? get(
              enrollment,
              "autoEnrollment.investmentElectionBasedOnList.0.id",
              0
            )
          : 0,
        ageFrom: null,
        ageTo: null,
        autoEnrollmentId: get(enrollment, "autoEnrollment.id", 0),
        from: null,
        investmentBasedOn: null,
        to: null,
        investmentElectionValuesList: Avalues.sameInvestmentElectionToAllSources
          ? autoEnrollmentInvestmentElectionsMap
          : autoEnrollmentSouceInvestmentElectionsList,
      });
    } else if (Avalues.sameInvestmentElectionToAllParticipants === false) {
      investmentElectionBasedOnList.push({
        isDefaultCategory: true,
        autoEnrollmentId: get(enrollment, "autoEnrollment.id", 0),
        investmentElectionValuesList: differentInvestmentElectionList.filter(
          (_) => parseInt(_.investmentElectionBasedOnIndex) == 0
        ),
      });
      const newInvestmentElectionBasedOnList = Avalues.InvestmentElectionBasedOnList.filter(
        (_) => !_.isDefaultCategory
      );
      for (let i in newInvestmentElectionBasedOnList) {
        investmentElectionBasedOnList.push({
          ...newInvestmentElectionBasedOnList[i],
          autoEnrollmentId: get(enrollment, "autoEnrollment.id", 0),
          investmentElectionValuesList: differentInvestmentElectionList.filter(
            (_) => {
              return (
                parseInt(_.investmentElectionBasedOnIndex) === parseInt(i) + 1
              );
            }
          ),
        });
      }
    }

    return investmentElectionBasedOnList;
  };
  const onFormSubmit = (
    values,
    { setFieldTouched, setValues, setFieldError, setFieldValue, setSubmitting }
  ) => {
    dispatch(
      setManagePlanLocalCache({
        model: "AutoEnrollment",
        data: values,
      })
    );
    const Avalues = values?.autoEnrollment;
    const {
      InvestmentElectionBasedOnList,
      subjecttoAutoEnrollment,
      ...otherAvalues
    } = Avalues;
    setIsLoading(true);

    const excludedEmployeeClassifications = (
      Avalues?.excludedEmployeeClassifications ?? []
    ).map((source) => {
      const match = get(
        employeeClassification,
        "employeeClassifications",
        []
      ).filter((x) => x.code === source)[0];
      return {
        codeName: match?.codeName,
        code: match?.code,
        id: get(source, "id", 0),
        autoEnrollmentId: get(enrollment, "autoEnrollment.id", 0),
      };
    });

    const excludedEmploymentStatuses = (
      Avalues?.excludedEmploymentStatuses ?? []
    ).map((source) => {
      const match = get(
        employeeClassification,
        "employmentStatuses",
        []
      ).filter((x) => x.employmentStatusCode === source)[0];
      return {
        employmentStatusName: match?.employmentStatusName,
        employmentStatusCode: match?.employmentStatusCode,
        id: get(source, "id", 0),
        autoEnrollmentId: get(enrollment, "autoEnrollment.id", 0),
      };
    });

    const autoEnrollmentDeferralSources = Avalues[
      fields.usePlanDefaultDeferralElection
    ]
      ? get(values, "deferralSourceContributions", []).map((_, ind) => {
          const foundSource = get(
            Avalues,
            "autoEnrollmentDeferralSources",
            []
          ).find((el) => el.sourceId === _.sourceId);
          return {
            ..._,
            id: foundSource ? foundSource.id : 0,
            sourceId: transformedEmployeeDeferralSourceList[ind].sourceId,
            deferralSourceName:
              transformedEmployeeDeferralSourceList[ind].sourceName,
            deferralSourcePercentage: _.contributionRate,
            limitMaximumDollar:
              transformedEmployeeDeferralSourceList[ind].limitMaximumDollar,
            limitMinimumDollar:
              transformedEmployeeDeferralSourceList[ind].limitMinimumDollar,
            autoEnrollmentId: get(enrollment, "autoEnrollment.id", 0),
          };
        })
      : transformedEmployeeDeferralSourceList.map((source, i) => {
          const foundSource = get(
            Avalues,
            "autoEnrollmentDeferralSources",
            []
          ).find((el) => el.sourceId === source.sourceId);
          return foundSource
            ? foundSource
            : {
                id: 0,
                deferralSourceName: source?.sourceName,
                limitMinimumDollar: source?.limitMinimumDollar,
                limitMaximumDollar: source?.limitMaximumDollar,
                deferralSourcePercentage: null,
                autoEnrollmentId: get(enrollment, "autoEnrollment.id", 0),
              };
        });
    saveEnrollmentSetting({
      id: get(enrollment, "id", 0),
      planId: parseInt(planId),
      defaultElectionSetting: prepDataDefaultElectionSetting(values),
      autoDeferralncreaseApplicable: preDataAdi(values),
      otherInformation: {
        enrollmentId: get(enrollment, "id", 0),
        id: get(getOtherInformationInitialValues, "id", 0),
        allowReallocation: get(
          values,
          "enrollmentOtherInformation.allowReallocation"
        ),
        reallocationPeriod: get(
          values,
          "enrollmentOtherInformation.reAllocationPeriod"
        ),
        numberOfReallocationsAllowed: get(
          values,
          "enrollmentOtherInformation.numberOfReallocationAllowed"
        ),
        sendEnrollmentInvite: get(
          values,
          "enrollmentOtherInformation.sendEnrollmentInvite"
        ),
        numberOfDaysBeforeEntryDate: get(
          values,
          "enrollmentOtherInformation.numberOfDaysBeforeEntryDate"
        ),
      },
      reAllocationEnrollmentInvite: prepareReallocationOtherInformation(values),

      autoEnrollment: !subjecttoAutoEnrollment
        ? {
            enrollmentId: get(enrollment, "id", 0),
            id: get(enrollment, "autoEnrollment.id", 0),
            planId: parseInt(planId),
            subjecttoAutoEnrollment: false,
          }
        : {
            ...otherAvalues,
            id: get(enrollment, "autoEnrollment.id", 0),
            subjecttoAutoEnrollment: subjecttoAutoEnrollment,
            investmentElectionBasedOnList: synchronizeCollectionInvestmentElectionBasedOnList(
              get(
                enrollment,
                "autoEnrollment.investmentElectionBasedOnList",
                []
              ),
              convertAutoEnrollmentValues(values),
              false
            ),
            excludedEmployeeClassifications: synchronizeCollectionNew(
              get(
                enrollment,
                "autoEnrollment.excludedEmployeeClassifications",
                []
              ),
              excludedEmployeeClassifications,
              "id"
            ),
            excludedEmploymentStatuses: synchronizeCollectionNew(
              get(enrollment, "autoEnrollment.excludedEmploymentStatuses", []),
              excludedEmploymentStatuses,
              "id"
            ),
            autoEnrollmentDeferralSources: synchronizeCollectionNew(
              get(
                enrollment,
                "autoEnrollment.autoEnrollmentDeferralSources",
                []
              ),
              autoEnrollmentDeferralSources,
              "id"
            ),

            autoEnrollmentSouceInvestmentElections: isEmpty(
              Avalues.autoEnrollmentSouceInvestmentElections
            )
              ? null
              : Avalues.autoEnrollmentSouceInvestmentElections.map(
                  (source, i) => {
                    if (isEmpty(source)) {
                      return [
                        {
                          id: 0,
                          investmentName: null,
                          sourceName: sourceList[i]?.sourceName,
                          investmentPercentage: 0,
                          autoEnrollmentId: get(
                            enrollment,
                            "autoEnrollment.id",
                            0
                          ),
                        },
                      ];
                    }
                    return source;
                  }
                ),
            differentInvestmentElection: isEmpty(
              Avalues.differentInvestmentElection
            )
              ? null
              : Avalues.differentInvestmentElection.map((source, i) => {
                  if (isEmpty(source)) {
                    return [
                      [
                        {
                          id: 0,
                          investmentName: null,
                          sourceName: sourceList[i]?.sourceName,
                          investmentPercentage: 0,
                          autoEnrollmentId: get(
                            enrollment,
                            "autoEnrollment.id",
                            0
                          ),
                        },
                      ],
                    ];
                  }
                  return source;
                }),
            additionalAutoEnrollment: synchronizeCollectionNew(
              enrollment?.autoEnrollment?.additionalAutoEnrollment ?? [],
              AdditionalAutoEnrollment.map((value) => {
                const addAdditionalAutoEnrollment = {
                  ...value,
                  excludedEmployeeClassifications: isEmpty(
                    value.excludedEmployeeClassifications
                  )
                    ? null
                    : value.excludedEmployeeClassifications.map((source) => {
                        const match = employeeClassification.employeeClassifications.filter(
                          (x) => x.code === source.code
                        )[0];
                        return {
                          codeName: match.codeName,
                          code: match.code,
                          id: source.id ? 0 : source.id,
                          additionalAutoEnrollmentId: value?.id || 0,
                        };
                      }),
                  excludedEmploymentStatuses: isEmpty(
                    value.excludedEmploymentStatuses
                  )
                    ? null
                    : value.excludedEmploymentStatuses.map((source) => {
                        const match = employeeClassification.employmentStatuses.filter(
                          (x) =>
                            x.employmentStatusCode ===
                            source.employmentStatusCode
                        )[0];

                        return {
                          employmentStatusName: match.employmentStatusName,
                          employmentStatusCode: match.employmentStatusCode,
                          id: source.id || 0,
                          additionalAutoEnrollmentId: value?.id || 0,
                        };
                      }),
                  additionalAutoEnrollmentDeferralSources: value[
                    fields.usePlanDefaultDeferralElection
                  ]
                    ? get(values, "deferralSourceContributions", []).map(
                        (_, ind) => {
                          return {
                            ..._,
                            id: 0,
                            sourceId:
                              transformedEmployeeDeferralSourceList[ind]
                                .sourceId,
                            deferralSourceName:
                              transformedEmployeeDeferralSourceList[ind]
                                .sourceName,
                            deferralSourcePercentage: _.contributionRate,
                            limitMaximumDollar:
                              transformedEmployeeDeferralSourceList[ind]
                                .limitMaximumDollar,
                            limitMinimumDollar:
                              transformedEmployeeDeferralSourceList[ind]
                                .limitMinimumDollar,
                            additionalAutoEnrollmentId: value?.id || 0,
                          };
                        }
                      )
                    : isEmpty(value.additionalAutoEnrollmentDeferralSources)
                    ? null
                    : value.additionalAutoEnrollmentDeferralSources.map(
                        (source, i) => {
                          if (isEmpty(source)) {
                            return {
                              id: source.id || 0,
                              deferralSourceName:
                                transformedEmployeeDeferralSourceList[i]
                                  .sourceName,
                              limitMinimumDollar:
                                transformedEmployeeDeferralSourceList[i]
                                  .limitMinimumDollar,
                              limitMaximumDollar:
                                transformedEmployeeDeferralSourceList[i]
                                  .limitMaximumDollar,
                              deferralSourcePercentage: null,
                              additionalAutoEnrollmentId: value?.id || 0,
                            };
                          }
                          return source;
                        }
                      ),
                  // additionalAutoEnrollmentSourceInvestmentElections: isEmpty(
                  //   value.additionalAutoEnrollmentSouceInvestmentElections
                  // )
                  //   ? null
                  //   : value.additionalAutoEnrollmentSouceInvestmentElections.map(
                  //       (source, i) => {
                  //         if (isEmpty(source)) {
                  //           return [
                  //             {
                  //               id: 0,
                  //               investmentName: null,
                  //               sourceName: sourceList[i].sourceName,
                  //               investmentPercentage: 0,
                  //             },
                  //           ];
                  //         }
                  //         return source;
                  //       }
                  //     ),
                  // additionalAutoEnrollmentDifferentInvestmentElection: isEmpty(
                  //   value.additionalAutoEnrollmentDifferentInvestmentElection
                  // )
                  //   ? null
                  //   : value.additionalAutoEnrollmentDifferentInvestmentElection.map(
                  //       (source, i) => {
                  //         if (isEmpty(source)) {
                  //           return [
                  //             [
                  //               {
                  //                 id: 0,
                  //                 investmentName: null,
                  //                 sourceName: sourceList[i].sourceName,
                  //                 investmentPercentage: 0,
                  //               },
                  //             ],
                  //           ];
                  //         }
                  //         return source;
                  //       }
                  //     ),
                };
                return addAdditionalAutoEnrollment;
              }),
              "id"
            ),
          },
    })
      .then((response) => {
        setIsLoading(false);
        //setCommonError('')
        if (response.isSuccessful) {
          setCommonError("");
          setIsSuccessFullySaved(true);
          // setValues({
          //   ...values,
          //   icons: {
          //     Icolor: "#2F80ED",
          //     I1color: "#2F80ED",
          //     I2color: "#2F80ED",
          //     I3color: "#2F80ED",
          //   },
          // });
          // commonSave();
          saveTab1();
          // const newPlanId = get(response, "plan.id");
          // const newCompanyId = get(response, "plan.companyId");
          // dispatch(updateAutoEnrollment(Avalues));
          dispatch(clearLocalCacheByModel("AutoEnrollment"));
          dispatch(
            setManagePlanLocalCache({
              model: "enrollment",
              data: response.enrollment,
            })
          );
          dispatch(clearLocalCacheByModel("AdditionalAutoEnrollment"));
          // dispatch(
          //   setManagePlanFlow({
          //     planId: newPlanId,
          //     companyId: newCompanyId,
          //   })
          // );
          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_PLAN_ROUTES.ENROLLMENT,
              pathParam: [FLOW_TYPES.EDIT, planId],
            })
          );
          dispatch(
            setManagePlanToastInfo({
              showToast: true,
              toastMessage: "Data saved successfully",
            })
          );
        } else {
          setIsSuccessFullySaved(false);

          //var index = 0;
          setTabState("error");
          setIsSaved1(false);
          let controlNames = response.errorMessages.map((_) => _.controlName);
          if (
            controlNames.filter((_) =>
              _.includes("deferralSourceContributions")
            ).length > 0
          ) {
            setFieldValue("icons.I", "faExclamationTriangle");
            //setIcolor("#EB5757");
            setFieldValue("icons.Icolor", "#EB5757");
          } else {
            setFieldValue("icons.I", "faCheckCircle");
            //setIcolor("#2F80ED");
            setFieldValue("icons.Icolor", "#2F80ED");
          }
          if (
            controlNames.filter((_) =>
              _.includes("autoDeferralncreaseApplicable")
            ).length > 0
          ) {
            // setI1(faExclamationTriangle);
            setFieldValue("icons.I1", "faExclamationTriangle");

            // setI1color("#EB5757");
            setFieldValue("icons.I1color", "#EB5757");
          } else {
            // setI1(faCheckCircle);
            setFieldValue("icons.I1", "faCheckCircle");
            //setI1color("#2F80ED");
            setFieldValue("icons.I1color", "#2F80ED");
          }
          if (
            controlNames.filter((_) => _.includes("autoEnrollment")).length > 0
          ) {
            setFieldValue("icons.I2", "faExclamationTriangle");
            //setI2color("#EB5757");
            setFieldValue("icons.I2color", "#EB5757");
          } else {
            setFieldValue("icons.I2", "faCheckCircle");
            //setI2color("#2F80ED");
            setFieldValue("icons.I2color", "#2F80ED");
          }
          if (
            controlNames.filter((_) => _.includes("enrollmentOtherInformation"))
              .length > 0
          ) {
            setFieldValue("icons.I3", "faExclamationTriangle");
            //setI3color("#EB5757");
            setFieldValue("icons.I3color", "#EB5757");
          } else {
            setFieldValue("icons.I3", "faCheckCircle");
            //setI3color("#2F80ED");
            setFieldValue("icons.I3color", "#2F80ED");
          }

          for (var i = 0; i < response.errorMessages.length; i++) {
            var _ = response.errorMessages[i];
            if (_.controlName === "planInvestment")
              setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
            else {
              setFieldTouched(_.controlName, true);
              setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
              if (_.controlName.includes("autoDeferralncreaseApplicable.adi")) {
                let newControl = _.controlName.replace(
                  "autoDeferralncreaseApplicable.",
                  ""
                );
                setFieldTouched(newControl, true);
                setFieldError(newControl, `${_.errorCode} : ${_.message}`);
              }
            }
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  useDeepEffect(() => {
    setITabcolor("#bdbdbd");
    setI1Tabcolor("#bdbdbd");
    setI2Tabcolor("#bdbdbd");
    setI3Tabcolor("#bdbdbd");

    if (keyValue === 1) {
      setITabcolor("#007bff");
    } else if (keyValue === 2) {
      setI1Tabcolor("#007bff");
    } else {
      setI2Tabcolor("#007bff");
    }

    if (
      isSaved1 &&
      (isSaved2 === true || isSaved2 === null) &&
      (isSaved3 === true || isSaved3 === null)
    ) {
      commonSave();
    }
  }, [isSaved1, isSaved2, isSaved3]);
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;

  const tabDefaultElection = () => {
    menuChange(1);
  };

  const tabADIApplicable = () => {
    menuChange(2);
  };

  const tabAutoEnrollment = () => {
    menuChange(3);
  };
  const tabOtherInfo = () => {
    menuChange(4);
  };
  const getEnrollmentInitialValues = !isEmpty(initialValuesFromLocalCache)
    ? initialValuesFromLocalCache
    : {
        autoEnrollment: autoEnrollmentInitialValues,
        sourceList: sourceList,
        investmentList: investmentList,
        deferralSourceContributions: transformedEmployeeDeferralSourceList.map(
          (_) => {
            let temp = (
              getDefaultElection?.deferralSourceContribution ?? []
            ).find((itm) => itm.sourceId === _.sourceId);
            return temp != undefined && temp != -1 ? temp : _;
          }
        ),
        planInvestment: planInvestment,
        defaultElectionSetting: getDefaultElection,
        adi: adiSources(),
        autoDeferralncreaseApplicable: autoDeferralncreaseApplicable,
        enrollmentOtherInformation: getOtherInformationInitialValues,
        icons: { ...iconsInitialValues },
        // icons2:{I2color:"#EB5757"},
      };
  return (
    <Formik
      initialValues={getEnrollmentInitialValues}
      onSubmit={onFormSubmit}
      validateOnChange={false}
      validateOnBlur={false}
      enableReinitialize
    >
      {(formProps) => {
        const {
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          setTouched,
          values,
          setSubmitting,
          isSubmitting,
          ...rest
        } = formProps;
        const iconStyles = isSuccessFullySaved
          ? iconsInitialValues
          : get(values, "icons", {});
        console.log("enrollment-values", values);

        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <ManagePlanLayout
              buttons={buttons}
              pageFlow={newFlow || flow}
              onFormRefresh={() => {
                dispatch(clearLocalCacheByModel("AutoEnrollment"));
              }}
            >
              <LoaderWrapper isLoading={isLoading}>
                <div className="mt-3">
                  <Tabs
                    defaultActiveKey={1}
                    transition={false}
                    activeKey={keyValue}
                    onSelect={menuChange}
                    className="top-level-tab-enrollment"
                    //id={tabState}
                    mountOnEnter
                    unmountOnExit
                  >
                    <Tab
                      eventKey={1}
                      npm
                      className="EnrollmentTabs"
                      title={
                        <span
                          style={{
                            padding: "10px 0px 0px 0px",
                            borderTop: `3px solid ${
                              keyValue == 1 ? "#007bff" : "#bdbdbd"
                            }`,
                          }}
                        >
                          <FontAwesomeIcon
                            icon={iconMap[get(iconStyles, "I")]}
                            size="sm"
                            color={get(iconStyles, "Icolor")}
                          />{" "}
                          Default Election{" "}
                          {/* {keyValue===1?<b>Default Election</b>:"Default Election"} */}
                        </span>
                      }
                    >
                      <DefaultElectionContainer
                        {...formProps}
                        fields={fields}
                        isEdit={isEdit}
                        isSave={isSave}
                        planId={planId}
                        setToggle={setToggle}
                        toggle={toggle}
                        commonError={commonError}
                        transformedEmployeeDeferralSourceList={
                          transformedEmployeeDeferralSourceList
                        }
                      />
                      {isEdit == true ? null : (
                        <Button className="mt-3" onClick={tabADIApplicable}>
                          Next
                        </Button>
                      )}
                    </Tab>
                    <Tab
                      eventKey={2}
                      title={
                        <span
                          style={{
                            padding: "10px 0px 0px 0px",
                            borderTop: `3px solid ${
                              keyValue == 2 ? "#007bff" : "#bdbdbd"
                            }`,
                          }}
                        >
                          <FontAwesomeIcon
                            icon={iconMap[get(iconStyles, "I1")]}
                            size="sm"
                            color={get(iconStyles, "I1color")}
                          />{" "}
                          ADI Applicable
                        </span>
                      }
                    >
                      <ADIApplicableFields
                        {...formProps}
                        fields={fields}
                        isEdit={isEdit}
                        isSave={isSave}
                        planId={planId}
                        transformedEmployeeDeferralSourceList={
                          transformedEmployeeDeferralSourceList
                        }
                        adiSources={adiSources}
                      />
                      {isEdit == true ? null : (
                        <>
                          <Button
                            className="add-btn mr-4"
                            variant="secondary"
                            onClick={tabDefaultElection}
                          >
                            Previous
                          </Button>
                          <Button onClick={tabAutoEnrollment}>Next</Button>
                        </>
                      )}
                    </Tab>
                    <Tab
                      eventKey={3}
                      title={
                        <span
                          style={{
                            padding: "10px 0px 0px 0px",
                            borderTop: `3px solid ${
                              keyValue == 3 ? "#007bff" : "#bdbdbd"
                            }`,
                          }}
                        >
                          <FontAwesomeIcon
                            icon={iconMap[get(iconStyles, "I2")]}
                            size="sm"
                            color={get(iconStyles, "I2color")}
                          />{" "}
                          Auto Enrollment
                        </span>
                      }
                    >
                      <AutoEnrollment
                        {...formProps}
                        {...props}
                        sourcesList={sourceList}
                        transformedEmployeeDeferralSourceList={
                          transformedEmployeeDeferralSourceList
                        }
                        investmentList={investmentList}
                        fields={fields}
                        isEdit={isEdit}
                        isSave={isSave}
                        planId={planId}
                        history={history}
                        getDefaultElection={getDefaultElection}
                        setAvalues={setAvalues}
                        Avalues={Avalues}
                        setToggle={setToggle}
                        toggle={toggle}
                      />
                      {isEdit == true ? null : (
                        <>
                          <Button
                            className="add-btn mr-4"
                            variant="secondary"
                            onClick={tabADIApplicable}
                          >
                            Previous
                          </Button>
                          <Button onClick={tabOtherInfo}>Next</Button>
                        </>
                      )}
                    </Tab>

                    <Tab
                      eventKey={4}
                      title={
                        <span
                          style={{
                            padding: "10px 0px 0px 0px",
                            borderTop: `3px solid ${
                              keyValue == 4 ? "#007bff" : "#bdbdbd"
                            }`,
                          }}
                        >
                          <FontAwesomeIcon
                            icon={iconMap[get(iconStyles, "I3")]}
                            size="sm"
                            color={get(iconStyles, "I3color")}
                          />{" "}
                          Other Information
                        </span>
                      }
                    >
                      <OtherInformation
                        {...formProps}
                        {...props}
                        fields={fields}
                        isEdit={isEdit}
                        isSave={isSave}
                        planId={planId}
                        history={history}
                        setToggle={setToggle}
                        toggle={toggle}
                      />
                      {isEdit == true ? null : (
                        <>
                          <Button
                            className="add-btn mr-4"
                            variant="secondary"
                            onClick={tabAutoEnrollment}
                          >
                            Previous
                          </Button>
                          <Button type="submit">Save</Button>
                        </>
                      )}
                    </Tab>
                  </Tabs>
                </div>
              </LoaderWrapper>
            </ManagePlanLayout>
            <TabLeavingGuard
              {...{
                isInnerFormDirty,
                setIsInnerFormDirty,
                setkeyValue,
                nextkeyValue,
                setNextkeyValue,
                keyValue,
              }}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default EnrollmentContainer;
